import './App.css';
import Suggestions from './Suggestions';
import Suggest from './Suggest';
import Approval from './Approval';
import WeeklyPoll from './WeeklyPoll';
import Reviews from './Reviews';
import ReviewManager from './ReviewManager';
import CustomBar from './CustomBar';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import React, { useCallback, useState, useEffect } from 'react';
import axios from 'axios';

function App() {
  const [globalList, setGlobalList] = useState([]);
  const [isListLoading, setIsListLoading] = useState(true);
  const base_url = process.env.REACT_APP_API_BASE_URL || (
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:5000'
      : 'https://eliteari.pythonanywhere.com'
  );

  const fetchItems = useCallback(async () => {
    setIsListLoading(true);
    try {
      const response = await axios.get(`${base_url}/getlist`);
      setGlobalList(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsListLoading(false);
    }
  }, [base_url]);

  const addToList = async (movie) => {
    try {
      await axios.post(`${base_url}/additem`, { item: movie });
      fetchItems();
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const approveItem = async (movie) => {
    try {
      await axios.post(`${base_url}/approveitem`, { item: movie });
      fetchItems();
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const ariApprove = async (movie) => {
    try {
      await axios.post(`${base_url}/ariapprove`, { item: movie });
      fetchItems();
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  const removeItem = async (movie) => {
    try {
      await axios.post(`${base_url}/removeitem`, { item: movie });
      fetchItems();
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  return (
    <Router>
      <CustomBar />
      <Routes>
        <Route path="/" element={<WeeklyPoll baseUrl={base_url}/>}/>
        <Route path="/about" element={<Navigate to="/reviews" replace />} />
        <Route path="/reviews" element={<Reviews baseUrl={base_url}/>} />
        <Route path="/reviews/manage" element={<ReviewManager baseUrl={base_url}/>} />
        <Route path="/suggest" element={<Suggest addToList={addToList} myList={globalList} baseUrl={base_url} isListLoading={isListLoading}/>}/>
        <Route path="/poll" element={<WeeklyPoll baseUrl={base_url}/>}/>
        <Route path="/suggestions" element={<Suggestions/>}/>
        <Route path="/approval" element={<Approval approveItem={approveItem} removeItem={removeItem} ariApprove={ariApprove} myList={globalList}/>}/>
      </Routes>
    </Router>
  );
}

export default App;
